import { viewCarrierStructure } from '@/constants/carriers-constants';

const basicCost = viewCarrierStructure.basicCost;
const moreInfo = viewCarrierStructure.moreInfo;
export const carriersEn = {
  [basicCost.section1.part1.chModel]: 'Chassis Model',
  [basicCost.section1.part1.chNo]: 'Chassis Number',
  [basicCost.section1.part1.make]: 'Make',
  [basicCost.section1.part1.model]: 'Model',
  [basicCost.section1.part1.stock]: 'Stock',
  [basicCost.section1.part1.fuelType]: 'Fuel Type',
  [basicCost.section1.part1.modelCode]: 'Model Code',
  [basicCost.section1.part1.category]: 'Category',
  [basicCost.section1.part1.exportCategory]: 'Export Category',
  [basicCost.section1.part1.engineYearMonth]: 'Month/Year',

  [basicCost.section1.part2.extColor]: 'Colour',
  [basicCost.section1.part2.transmission]: 'Transmission',
  [basicCost.section1.part2.traction]: 'Traction',
  [basicCost.section1.part2.drive]: 'Drive',
  [basicCost.section1.part2.powerKw]: 'Power(KW)',
  [basicCost.section1.part2.powerCc]: 'Power(CC)',
  [basicCost.section1.part2.doors]: 'Doors',
  [basicCost.section1.part2.capacity]: 'Max Load',
  [basicCost.section1.part2.seating]: 'Seating',
  [basicCost.section1.part2.interiorColour]: 'Interior Colour',
  [basicCost.section1.part2.condition]: 'Condition',
  [basicCost.section1.part2.driveKM]: 'Kilometers',
  [basicCost.section1.part2.engineType]: 'Engine Type',
  [basicCost.section1.part2.engineNo]: 'Engine Number',
  [basicCost.section1.part2.ichijiMacho]: 'Ichiji Macho',

  [basicCost.section1.part3.auctionBy]: 'Auction By',
  [basicCost.section1.part3.purchasedDate]: 'Purchased On',
  [basicCost.section1.part3.lotNo]: 'Lot Number',
  [basicCost.section1.part3.runNo]: 'Running Number',
  [basicCost.section1.part3.bidder]: 'Bidder',
  [basicCost.section1.part3.auctionDate]: 'Auction Date',
  [basicCost.section1.part3.salesPerson]: 'Sales Person',
  [basicCost.section1.part3.location]: 'Location',
  [basicCost.section1.part3.auctionGrade]: 'Auction Grade',
  [basicCost.section1.part3.dealer]: 'Dealer',
  [basicCost.section1.part3.seller]: 'Seller',

  [basicCost.section2.fobPrice]: 'FOB Price',
  [basicCost.section2.totalCost]: 'Total Cost',
  [basicCost.section2.salePercent]: 'Sale %',
  [basicCost.section2.saleResult]: 'Sale Result',
  [basicCost.section2.saleAmt]: 'Sale Amount',
  [basicCost.section2.basicCost.buyPrice]: 'Buy Price',
  [basicCost.section2.basicCost.aucFee]: 'Auction Fee',
  [basicCost.section2.basicCost.riksoFeeTax]: 'Transport Fee Tax',
  [basicCost.section2.basicCost.recycleFee]: 'Recycle Fee',
  [basicCost.section2.basicCost.buyPriceTax]: 'Buy Price Tax',
  [basicCost.section2.basicCost.aucFeeTax]: 'Auction Fee Tax',
  [basicCost.section2.basicCost.riksoFee]: 'Transport Fee',
  [basicCost.section2.basicCost.jidoushaZei]: 'Jidousha Zei',
  [basicCost.section2.basicCost.inspectionFee]: 'Inspection Fee',
  [basicCost.section2.basicCost.inspectionFeeTax]: 'Inspection Fee Tax',

  [basicCost.section2.saleCost.aucListFee]: 'Auction List Fee',
  [basicCost.section2.saleCost.aucSellingFee]: 'Auction Selling Fee',
  [basicCost.section2.saleCost.forwardingCost]: 'Total Port Forwarding',
  [basicCost.section2.saleCost.freightFee]: 'Freight Fee',
  [basicCost.section2.saleCost.insuranceFee]: 'Insurance Fee',
  [basicCost.section2.saleCost.portRemovalFee]: 'Port Removal Fee',
  [basicCost.section2.saleCost.radioActive]: 'Radio Active',
  [basicCost.section2.saleCost.storageFee]: 'Storage Fee',

  [basicCost.section2.additionalCost.shaken]: 'Vehicle Inspection (Shaken)',
  [basicCost.section2.additionalCost.shakenReceived]: 'Shaken Received',
  [basicCost.section2.additionalCost.claimCost]: 'Claim Cost',

  [basicCost.section2.additionalCost.parkingPenalty]: 'Parking Penalty',
  [basicCost.section2.additionalCost.misc]: 'Miscellaneous',

  [basicCost.section2.creditCost.claimCredit]: 'Claim Credit',
  [basicCost.section2.creditCost.discCredit]: 'Discount Credit',
  [basicCost.section2.creditCost.recyleFeeRefund]: 'Recycle Fee Refund',
  [basicCost.section2.creditCost.jidoushaZeinRefund]: 'Jidousha Zei Refund',
  [basicCost.section2.creditCost.lateDocCredit]: 'Late Doc Credit',

  [moreInfo.goods.action]: 'Action',
  [moreInfo.goods.description]: 'Description',
  [moreInfo.goods.received]: 'Received',
  [moreInfo.goods.done]: 'Done',
  [moreInfo.goods.courier]: 'Courier',
  [moreInfo.goods.awb]: 'AWB',
  [moreInfo.bodyDimensions.carArea]: 'Area (m³)',
  [moreInfo.bodyDimensions.carHeight]: 'Height (cm)',
  [moreInfo.bodyDimensions.carLength]: 'Length (cm)',
  [moreInfo.bodyDimensions.carWidth]: 'Width (cm)',
  [moreInfo.bodyDimensions.carryingWeight]: 'Carrying Weight (kg)',
  [moreInfo.bodyDimensions.grossWeight]: 'Gross Weight (kg)',
  [moreInfo.bodyDimensions.netWeight]: 'Net Weight (kg)',
  [moreInfo.bodyDimensions.n1]: 'N1',
  [moreInfo.bodyDimensions.n2]: 'N2',
  [moreInfo.bodyDimensions.n3]: 'N3',
  [moreInfo.bodyDimensions.n4]: 'N4',

  [moreInfo.properties.ac]: 'AC',
  [moreInfo.properties.abs]: 'ABS',
  [moreInfo.properties.autoWindow]: 'Auto Window',
  [moreInfo.properties.backCam]: 'Back Cam',
  [moreInfo.properties.bluetooth]: 'Bluetooth',
  [moreInfo.properties.bodyKit]: 'Body Kit',
  [moreInfo.properties.bothSidePowerSlideDoor]: 'Both Side Power Slide Door',
  [moreInfo.properties.camera360]: 'Camera 360',
  [moreInfo.properties.centralLock]: 'Central Lock',
  [moreInfo.properties.cornerSensor]: 'Corner Sensor',
  [moreInfo.properties.displayAudio]: 'Display Audio',
  [moreInfo.properties.fogLights]: 'Fog Lights',
  [moreInfo.properties.leatherSeats]: 'Leather Seats',
  [moreInfo.properties.led]: 'LED',
  [moreInfo.properties.navigation]: 'Navigation',
  [moreInfo.properties.oneOwner]: 'One Owner',
  [moreInfo.properties.oneSidePowerSlideDoor]: 'One Side Power Slide Door',
  [moreInfo.properties.panoramaRoof]: 'Panorama Roof',
  [moreInfo.properties.powerMirror]: 'Power Mirror',
  [moreInfo.properties.powerSeats]: 'Power Seats',
  [moreInfo.properties.powerSlideDoor]: 'Power Slide Door',
  [moreInfo.properties.powerSteering]: 'Power Steering',
  [moreInfo.properties.powerWindows]: 'Power Windows',
  [moreInfo.properties.rearSpoiler]: 'Rear Spoiler',
  [moreInfo.properties.roofRail]: 'Roof Rail',
  [moreInfo.properties.srsAirbags]: 'SRS Airbags',
  [moreInfo.properties.sunRoof]: 'Sun Roof',
  [moreInfo.properties.tv]: 'TV',
} as const;
